export const styles = {
  heading: {
    margin: 0,
    color: "#673ab7",
    fontWeight: 600,
  },
  searchAndFilter: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
  },
  headContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "0 0 10px 0",
  },
  flexContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "10px",
  },
  switch_Cont: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "5px",
    marginRight: "20px",
  },
  container: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    height: "fit-content",
    width: 500,
    bgcolor: "background.paper",
    border: "1px solid lightGray",
    boxShadow: 24,
    borderRadius: "12px",
  },
  headingBar: {
    width: "100%",
    height: "50px",
    display: "flex",
    borderBottom: "1px solid lightGray",
    alignItems: "center",
    padding: "20px 10px 0px 20px",
    boxSizing: "border-box",
  },

  heading_ac: {
    color: "#673ab7",
    margin: 0,
  },
  button: {
    padding: "10px 20px 20px 20px",
    display: "flex",
    alignItems: "center",
    marginTop: "15px ",
    gap: "20px",
    justifyContent: "flex-end",
  },
  button_box: {
    padding: "20px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: "15px ",
    gap: "20px",
  },

  inputBox: {
    padding: "20px",
    display: "block",
    justifyContent: "center",
    alignItems: "center",
  },
  input: {
    height: "150px",
    width: "150px",
    border: "1px dotted lightGray",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    margin: "6px 0px 6px 0px",
  },
  paper: {
    backgroundColor: "rgb(255, 255, 255)",
    color: "rgb(38, 38, 38)",
    transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    overflow: "hidden",
    border: "1px solid rgb(230, 235, 241)",
    borderRadius: "8px",
  },
  table: {
    fontFamily: "Roboto",
    display: "table",
    width: "100%",
    borderCollapse: "collapse",
    borderSpacing: "0px",
    marginBottom: "10px",
  },
  tableHeader: {
    "& th": {
      padding: "18px 16px",
      font: "normal normal 500 14px/18px Roboto",
      color: "#673AB7",
      whiteSpace: "nowrap",
    },
  },
  headerRow: {
    "& th": {
      textAlign: "center",
    },
  },
  noDataCell: {
    font: "normal normal 500 16px/24px Roboto",
    textAlign: "center",
    padding: "16px",
  },
  row: {
    "& td": {
      padding: "5px",
      maxWidth: "200px",
      overflow: "hidden",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      font: "normal normal 300 13px/18.2px Roboto",
      textAlign: "center",
    },
    "& td:nth-last-of-type(1)": {
      "& svg": {
        color: "#673AB7",
        cursor: "pointer",
        fontSize: "20px",
        margin: "0 2px",
      },
    },
  },
  modal: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "100%",
    maxWidth: 600,
    maxHeight: "90vh",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    bgcolor: "#fff",
    borderRadius: "14px",
    boxShadow: "0 20px 50px rgba(0, 0, 0, 0.18), 0 2px 6px rgba(0, 0, 0, 0.08)",
  },
  modalBody: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    minHeight: 0,
    maxHeight: "90vh",
    overflow: "hidden",
  },
  modalHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "20px 24px",
    borderBottom: "1px solid #e5e7eb",
    flexShrink: 0,
  },
  modalClose: {
    width: 32,
    height: 32,
    borderRadius: "8px",
    color: "#6b7280",
    "&:hover": {
      background: "#f3f4f6",
      color: "#111827",
    },
  },
  modalContent: {
    padding: "24px",
    overflowY: "auto",
    flex: 1,
    minHeight: 0,
  },
  modalFooter: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
    padding: "16px 24px",
    borderTop: "1px solid #e5e7eb",
    flexShrink: 0,
    background: "#fafafa",
  },
  selectDropdown: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "60px",
    fontSize: "0.8125rem",
    color: "#364152",
    fontWeight: "400",
    borderRadius: "12px",
    "& > div": {
      background: "none",
      color: "black",
      borderRadius: "12px",
      fontSize: "0.8125rem",
      fontWeight: "400",
    },
    "& fieldset": {
      color: "black",
      borderRadius: "8px",
    },
  },
  image: {
    height: "150px",
    width: "150px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "70px",
  },
  profileBox: {
    height: "160px",
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",
    paddingRight: "10px",
  },
  photoInput: {
    height: "150px",
    width: "150px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    border: "1px solid lightgray",
    background: "#F8FAFC",
    borderRadius: "75px",
  },
  fileField: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "60px",
    fontSize: "0.8125rem",
    color: "#364152",
    fontWeight: "400",
    borderRadius: "12px",
    "& > div": {
      background: "none",
      color: "black",
      borderRadius: "12px",
      fontSize: "0.8125rem",
      fontWeight: "400",
    },
    "& fieldset": {
      color: "black",
      borderRadius: "8px",
    },
  },
  csv_btn: {
    height: "45px",
    marginRight: "10px",
    borderRadius: "8px",
  },
  client_filter: {
    width: "110px",
    height: "45px",
    boxShadow: "none",
    fontSize: "30px",
    borderRadius: "8px",
  },
  addCategory: {
    top: "50%",
    width: 650,
    left: "50%",
    boxShadow: 24,
    height: "auto",
    borderRadius: "12px",
    position: "absolute",
    bgcolor: "background.paper",
    border: "1px solid lightGray",
    transform: "translate(-50%, -50%)",
  },
  icon: {
    position: "fixed",
    right: "10px",
    top: "5px",
  },
  mainContainerBox: {
    width: "100%",
    height: "80px",
    display: "flex",
    borderBottom: "1px solid lightGray",
    alignItems: "center",
    padding: "20px 10px 20px 20px",
    boxSizing: "border-box",
    justifyContent: "space-around",
  },
  EditheadingBar: {
    width: "100%",
    height: "50px",
    display: "flex",
    borderBottom: "1px solid lightGray",
    alignItems: "center",
    padding: "20px 10px 0px 20px",
    boxSizing: "border-box",
  },
  editModalContainer: {
    top: "50%",
    width: 550,
    left: "50%",
    boxShadow: 24,
    height: "200px",
    borderRadius: "12px",
    position: "absolute",
    bgcolor: "background.paper",
    border: "1px solid lightGray",
    transform: "translate(-50%, -50%)",
    padding: "10px 0px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-around",
    alignItems: "center",
  },
  editButtonBox: {
    padding: "5px 20px",
    display: "flex",
    justifyContent: "end",
    alignItems: "center",
    gap: "0px 20px",
    marginTop:"5px"
  },
  main_text_modal: {
    color: "#673ab7",
    textAlign: "center",
    margin: "22% 0 25% 0",
    fontWeight: "500",
    padding: "20px 0px",
    fontSize: "20px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",

    // margin:"10px",
  },
};
